import { render, staticRenderFns } from "./NotifyMeButton.vue?vue&type=template&id=28d082e4&scoped=true&"
import script from "./NotifyMeButton.vue?vue&type=script&lang=ts&"
export * from "./NotifyMeButton.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyMeButton.vue?vue&type=style&index=0&id=28d082e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d082e4",
  null
  
)

export default component.exports